<template>
  <div>
    <!-- filter start-->
    <div class="card-filter-section d-flex align-items-center justify-content-between mt-0">
      <p class="task-timesheet m-0">
        ACL Device
      </p>
   
      <div class="role-buttons d-flex flex-wrap align-items-center">
        <!-- add tag button  -->
        <table-button
          v-b-toggle.addacldevice
          btn-name="add device"
        />
        <!-- add tag button  -->
        <Help
          v-show="$store.state.app.userManualList"
          code="ACLD"
        />
      </div>
    </div>

    <div class="card-filter-section">
      <div class="d-flex align-items-center flex-wrap justify-content-between">
        <div class="d-flex align-items-center justify-content-start flex-wrap">
          <p class="filter-title">
            Filters:
          </p>

          <div>
            <custom-dropdown
              v-model="isAttendanceTrackingFilter"
              :options="attendanceTrackingOptions"
              :search-box="false"
              :hide-close="true"
              label="Attendance Tracking"
            />
          </div>

          <div>
            <custom-dropdown
              v-model="isDeviceAccessFilter"
              :options="deviceAccessOptions"
              :search-box="false"
              :hide-close="true"
              label="Office Access Device"
            />
          </div>

          <option-drop-down v-model="perPage" />
        </div>
        <div class="d-flex align-items-center">
          <b-input-group
            class="input-group-merge search-project"
            style="min-width: 250px; max-width: 250px; width: 250px"
          >
            <b-form-input
              v-model="debouncedSearch"
              placeholder="Search"
            />

            <b-input-group-append is-text>
              <feather-icon
                v-if="debouncedSearch"
                icon="XIcon"
                @click="debouncedSearch = null,search = null"
              />
              <feather-icon icon="SearchIcon" />
            </b-input-group-append>
          </b-input-group>

          <div class="ml-1">
            <button
              class="apply-filter filterRedesign mr-1"
              @click="getAclDeviceData(1)"
            >
              Apply Filter
            </button>
            <button
              class="apply-filter-clear filterRedesign"
              @click="clearFilter"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- filter end-->

    <div class="horizontal-line table">
      <!--Table start from here-->
      <table-loader
        v-if="loading"
        :fields="fields"
      />
      <b-row v-else>
        <b-col cols="12">
          <b-table
            striped
            hover
            responsive
            :items="aclDevices"
            :fields="fields"
            :sort-by.sync="sortBy1"
            :sort-desc.sync="sortDesc1"
            show-empty
            class="scrollable-element user-table-items  tableDesigns mastertblColor table-responsive device-table-items"
          >
            <template #cell(name)="data">
              <div class="media centeralign">
                <div>
                  <p
                    v-b-tooltip.hover.top="data.item.name"
                  >
                    {{ data.item.name }}
                  </p>
                </div>
              </div>
            </template>
            <template #cell(id)="data">
              <span>
                {{ data.item.id }}
              </span>
            </template>
            <template #cell(is_attendance_tracking)="data">
              <b-form-checkbox
                :checked="!!data.item.is_attendance_tracking"
                class="custom-control-success"
                name="check-button"
                size="md"
                switch
                @change="changeTracking(data.item)"
              >
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
              </b-form-checkbox>
            </template>
            <template #cell(is_device_access)="data">
              <b-form-checkbox
                :checked="!!data.item.is_device_access"
                class="custom-control-success"
                name="check-button"
                size="md"
                switch
                @change="changeDeviceAccess(data.item)"
              >
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
              </b-form-checkbox>
            </template>

            <template #cell(action)="data">
              <span>
                <feather-icon
                  v-b-tooltip.hover.top="'Edit'"
                  icon="EditIcon"
                  role="button"
                  class="mr-1 text-dark"
                  size="18"
                  @click="edit(data.item)"
                />

                <feather-icon
                  v-b-tooltip.hover.top="'Delete'"
                  icon="Trash2Icon"
                  role="button"
                  class="text-danger"
                  size="18"
                  @click="deleteConfirmation(data.item.id)"
                />
              </span>
            </template>
          </b-table>
          <img
            v-if="totalCount === 0"
            src="../../assets/images/nodatafound/nodata.svg"
            alt="no-data"
            class="no-data-img"
          >

        </b-col>
        <!-- data table end  here -->
      </b-row>
      <!-- pagination section start -->
      <Pagination
        v-if="totalCount > 0 && !loading"
        :current-page="currentPage"
        :per-page="perPage"
        :total-count="totalCount"
        @currentPage="currentPage = $event"
      />
      <!-- pagination section end -->

      <!-- from start -->
      <acl-device-table-form
        ref="AclDeviceTableForm"
        @aclDeviceList="getAclDeviceData"
      />

      <!-- form complete here -->
    </div>
  </div>
</template>


<script>
import aclDeviceList from '../../mixin/masterSetting/AclDevice/index'
import AclDeviceTableForm from '../../@core/components/table-from/AclDeviceTableForm.vue'
import customDropdown from '@/components/dropdown/customDropdown.vue'

export default {
  name: 'AclDevice',
  components: {
    AclDeviceTableForm,
    customDropdown,
  },
  mixins: [aclDeviceList],
}
</script>

<style lang="scss" scoped>
@import "./../../assets/scss/component-css/masterSettingFilter.scss";
</style>
